import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { useHistory } from "react-router-dom";
import moment from "moment-timezone";

const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
const CALENDAR_ID = "en.usa%23holiday@group.v.calendar.google.com";

function ShipmentCalendar({ activeShipments, deliveredShipments }) {
  const history = useHistory();
  const intl = useIntl();
  const [shipmentEvents, setShipmentEvents] = useState([]);
  const [holidayEvents, setHolidayEvents] = useState([]);

  useEffect(() => {
    const events = [];

    const shipments = [
      ...(activeShipments || []),
      ...(deliveredShipments || []),
    ];

    shipments.forEach(item => {
      events.push({
        id: item.id,
        title: intl.formatMessage({ id: "PICKUP" }),
        start: moment(
          item.originPickupOn || item.estimatedOriginPickupOn
        ).format("YYYY-MM-DD"),
        backgroundColor: "#FFA800",
        borderColor: "#FFA800",
        allDay: true,
        url: `/shipment/${item.id}`,
      });
      events.push({
        id: item.id,
        title: intl.formatMessage({ id: "DELIVERY" }),
        start: moment(item.deliveredOn || item.estimatedDeliveredOn).format(
          "YYYY-MM-DD"
        ),
        allDay: true,
        url: `/shipment/${item.id}`,
      });
    });

    setShipmentEvents(events);
  }, [activeShipments, deliveredShipments, intl]);

  useEffect(() => {
    if (!GOOGLE_API_KEY) {
      console.error("Google API key is missing");
      return;
    }

    const getHolidays = async () => {
      try {
        const response = await fetch(
          `https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_ID}/events?key=${GOOGLE_API_KEY}`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        const holidays = data.items.map(item => ({
          title: item.summary,
          start: item.start.date,
          allDay: true,
          backgroundColor: "#E32B00",
          borderColor: "#E32B00",
        }));
        setHolidayEvents(holidays);
      } catch (error) {
        console.error("Error fetching holidays:", error);
      }
    };

    getHolidays();
  }, []);

  const allEvents = [...shipmentEvents, ...holidayEvents];

  return (
    <FullCalendar
      plugins={[dayGridPlugin]}
      headerToolbar={{
        left: "",
        center: "title",
        right: "prev,next today",
      }}
      initialView="dayGridMonth"
      events={allEvents}
      locale={intl.locale}
      eventClick={({ event }) => {
        if (event.url) {
          history.push(event.url);
        }
      }}
    />
  );
}

export default ShipmentCalendar;
